/* ============================================================
   ODEN — Home page (template index)
   Script unique : onglets, sliders, carrousel agriculteurs,
   pagination avis, injection des notes produits.
   Chargé une seule fois, en defer.
   ============================================================ */
(function(){
  'use strict';

  /* ---- Notes produits (source unique, partagée onglets + routines) ---- */
  var RATINGS = {
    "serum-hydratant":[4.9,446],"huile-demaquillante":[4.9,996],"brume-rose-jasmin":[5.0,3],
    "concentre-eglantier":[4.9,1026],"creme-hydratante":[4.8,368],"serum-eclat":[4.9,134],
    "coffret-a-composer":[0,0],"concentre-deglantier-collector":[4.9,938],"crhy-shy":[5.0,8],
    "routines-rides-et-taches":[4.9,12],"trio-recharge":[5.0,8],"glow-duo":[4.9,30],
    "exfoliant-levres":[5.0,7],"trio-barrier-repair":[5.0,1],"duo-soin-levres":[5.0,1],
    "duo-a-composer":[0,0],"coffret-decouverte-huiles-visage":[0,0],"duo-best-seller":[5.0,25],
    "routine-peaux-mixtes-a-grasses":[4.9,70],"routine-peaux-matures":[4.9,64],
    "routine-peaux-seches":[5.0,21],"routine-peaux-sensibles":[4.9,29],"routine-peaux-normales":[4.9,17]
  };
  function fillRatings(){
    document.querySelectorAll('.oh-pcard__count[data-handle]').forEach(function(el){
      var p = RATINGS[el.dataset.handle];
      if(p && p[1] > 0){ el.textContent = p[0] + '/5 · ' + p[1] + ' avis'; }
      else { el.style.display = 'none'; }
    });
  }

  /* ---- Onglets collections ---- */
  function initTabs(){
    var btns = document.querySelectorAll('.oh-tab-btn');
    if(!btns.length) return;
    var link = document.getElementById('oh-tab-link');
    btns.forEach(function(btn){
      btn.addEventListener('click', function(){
        btns.forEach(function(b){ b.classList.remove('oh-tab-btn--active'); });
        document.querySelectorAll('.oh-tab-panel').forEach(function(p){ p.classList.remove('oh-tab-panel--active'); });
        btn.classList.add('oh-tab-btn--active');
        var tab = btn.dataset.tab;
        var panel = document.getElementById('oh-panel-' + tab);
        if(panel) panel.classList.add('oh-tab-panel--active');
        if(link) link.href = '/collections/' + tab;
      });
    });
  }

  /* ---- Slider presse (auto) ---- */
  function initPress(){
    var slides = document.querySelectorAll('.oh-press__slide');
    if(slides.length < 2) return;
    var i = 0;
    setInterval(function(){
      i = (i + 1) % slides.length;
      slides.forEach(function(s, n){ s.classList.toggle('oh-press__slide--active', n === i); });
    }, 5000);
  }

  /* ---- Carrousel agriculteurs (flèches desktop / scroll natif mobile) ---- */
  function initAgri(){
    var track = document.getElementById('oh-agri-track');
    if(!track) return;
    var cards = track.querySelectorAll('.oh-agri__card');
    var perPage = 4, current = 0, max = Math.max(0, cards.length - perPage);
    var isMobile = function(){ return window.innerWidth <= 749; };
    function slideTo(n){
      if(isMobile() || !cards.length) return;
      current = Math.max(0, Math.min(n, max));
      var w = cards[0].offsetWidth + 20;
      track.style.transform = 'translateX(-' + (current * w) + 'px)';
    }
    var prev = document.querySelector('.oh-agri__arrow--prev');
    var next = document.querySelector('.oh-agri__arrow--next');
    if(prev) prev.addEventListener('click', function(){ slideTo(current - 1); });
    if(next) next.addEventListener('click', function(){ slideTo(current + 1); });
    window.addEventListener('resize', function(){ if(!isMobile()) slideTo(current); });
  }

  /* ---- Pagination avis ---- */
  function initReviews(){
    var grid = document.getElementById('oh-rv-grid');
    if(!grid) return;
    var per = 3;
    var cards = grid.querySelectorAll('.oh-rv__card');
    var pages = document.querySelectorAll('.oh-rv__page');
    function go(n){
      cards.forEach(function(c){
        var i = parseInt(c.getAttribute('data-rv-idx'), 10);
        c.style.display = (i >= n * per && i < (n + 1) * per) ? 'flex' : 'none';
      });
      pages.forEach(function(b, i){ b.classList.toggle('oh-rv__page--active', i === n); });
    }
    pages.forEach(function(b, i){ b.addEventListener('click', function(){ go(i); }); });
    go(0);
  }

  function init(){ fillRatings(); initTabs(); initPress(); initAgri(); initReviews(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
